import {useEffect, useRef, useState} from "react";

export const useStorage = ({user}) => {
  const [activity, _setActivity] = useState({});
  const [watchHistory, _setWatchHistory] = useState({});

  const storageTimerRef = useRef(null);
  const latestDataRef = useRef({
    activity: {},
    watchHistory: {},
  });

  const storageKey = user?.customer_id ? `vp_${user.customer_id}` : null;

  useEffect(() => {
    latestDataRef.current = {
      activity,
      watchHistory,
    };
  }, [activity, watchHistory]);

  const scheduleStorageSave = (nextData) => {
    if (!storageKey) return;

    latestDataRef.current = {
      ...latestDataRef.current,
      ...nextData,
    };

    if (storageTimerRef.current) {
      clearTimeout(storageTimerRef.current);
    }

    storageTimerRef.current = setTimeout(() => {
      sessionStorage.setItem(storageKey, JSON.stringify(latestDataRef.current));
    }, 1000);
  };

  useEffect(() => {
    if (!user?.customer_id) return;

    const cached = storageKey ? sessionStorage.getItem(storageKey) : null;

    if (cached) {
      try {
        const {activity: act, watchHistory: wh} = JSON.parse(cached);

        if (act) {
          _setActivity(act);
          latestDataRef.current.activity = act;
        }

        if (wh) {
          _setWatchHistory(wh);
          latestDataRef.current.watchHistory = wh;
        }
      } catch (e) {
        console.error(e);
      }
    }
  }, [user, storageKey]);

  useEffect(() => {
    return () => {
      if (storageTimerRef.current) {
        clearTimeout(storageTimerRef.current);
      }

      if (storageKey) {
        sessionStorage.setItem(
          storageKey,
          JSON.stringify(latestDataRef.current),
        );
      }
    };
  }, [storageKey]);

  const setActivity = (activity) => {
    if (!storageKey) return;

    if (typeof activity === "function") {
      _setActivity((prev) => {
        const nextActivity = activity(prev);
        scheduleStorageSave({activity: nextActivity});
        return nextActivity;
      });
    } else if (typeof activity === "object") {
      _setActivity(activity);
      scheduleStorageSave({activity});
    }
  };

  const setWatchHistory = (watchHistory) => {
    if (!storageKey) return;

    if (typeof watchHistory === "function") {
      _setWatchHistory((prev) => {
        const nextWatchHistory = watchHistory(prev);
        scheduleStorageSave({watchHistory: nextWatchHistory});
        return nextWatchHistory;
      });
    } else if (typeof watchHistory === "object") {
      _setWatchHistory(watchHistory);
      scheduleStorageSave({watchHistory});
    }
  };

  return {
    activity,
    watchHistory,
    setActivity,
    setWatchHistory,
  };
};
